import { createAction, props } from '@ngrx/store';
import { Country } from '@shared/models/country';

export const loadCountries = createAction('[Countries] Load Countries');

export const loadCountriesSuccess = createAction('[Countries] Load Countries Success', props<{ data: Country[] }>());

export const loadCountriesFailure = createAction('[Countries] Load Countries Failure', props<{ error: any }>());
